import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { ThemeProvider } from "styled-components";
import "@suits/ss-design-system/dist/ss-components/styles/css/global.css";
import theme from "./core/styles/theme";
import GlobalStyles from "./core/styles/global";
import GlobalFonts from "./core/fonts/fonts";
import "./i18n";

const el = document.getElementById("EmailPreferenceCenter");

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App
        customerEmail={el.getAttribute("data-customerEmail")}
        authCode={el.getAttribute("data-authCode")}
        executedBy={el.getAttribute("data-executedBy")}
      />
      <GlobalStyles />
      <GlobalFonts />
    </ThemeProvider>
  </React.StrictMode>,
  el
);
